import { EnterpriseApi } from "@/api";
import i18n from "@/i18n";
import { showErrorSnackbar, showSuccessSnackbar } from "@/utilities/snackbar";
import { DownloadFile } from "@/utilities/fileManager.js";

export async function create(data) {
  await EnterpriseApi.create(data);
  showSuccessSnackbar(200, i18n.t("enterprise-created-correctly"));
}

export async function get(id) {
  const { data } = await EnterpriseApi.get(id);
  return data;
}

export async function clone(enterpriseId, data) {
  try {
    await EnterpriseApi.clone(enterpriseId, data);
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
  }
  showSuccessSnackbar(200, i18n.t("enterprise-cloned-correctly"));
}

export async function update(enterpriseId, data) {
  const { data: response } = await EnterpriseApi.update(enterpriseId, data);
  showSuccessSnackbar(200, i18n.t("enterprise-updated-correctly"));
  return response;
}

export async function toggle(enterpriseId) {
  try {
    await EnterpriseApi.toggle(enterpriseId);
  } catch (ex) {
    if (ex.response && ex.response.status === 409) {
      showErrorSnackbar(undefined, i18n.t("enterprise-max-limit-error"));
    } else {
      showErrorSnackbar(undefined, i18n.t("generic-error"));
    }
    throw ex;
  }
  showSuccessSnackbar(200, i18n.t("enterprise-updated-correctly"));
}

export async function exportCompiledEligibilityTests(enterpriseId) {
  try {
    const response = await EnterpriseApi.exportCompiledEligibilityTests(
      enterpriseId
    );
    // fallback: compiled_eligibility_tests_<data>.zip
    const gendate = new Date()
      .toISOString()
      .replace(/[-:]/g, "")
      .replace("T", "_")
      .replace("Z", "")
      .split(".")[0];
    const fallbackFileName = `compiled_eligibility_tests_${gendate}.zip`;
    DownloadFile.downloadBlobWithHeaders(
      response.data.file,
      response.headers,
      fallbackFileName
    );
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
  }
}
